var map = {
	"./1.png": "c1c5",
	"./2.png": "81e5",
	"./3.png": "619a",
	"./4.png": "33b2",
	"./5.png": "4660",
	"./6.png": "97ca",
	"./aboutus.jpg": "4eba",
	"./arrow.png": "061e",
	"./banner1.png": "d81f",
	"./banner2.png": "8813",
	"./banner3.png": "e5d4",
	"./bianc.png": "f21e",
	"./contactus.jpg": "6b5c",
	"./delay.jpg": "3b20",
	"./djk.jpg": "d311",
	"./feature.png": "35f6",
	"./grade.jpg": "5da0",
	"./guge.jpg": "b6e8",
	"./innove.jpg": "383e",
	"./line.png": "fe82",
	"./logic.jpg": "f036",
	"./logo.png": "9d64",
	"./logo2.png": "dd88",
	"./noip.png": "7975",
	"./noip2.jpg": "6413",
	"./play.png": "c4bf",
	"./pro1.png": "9817",
	"./pro2.png": "3f7c",
	"./pro3.png": "7a3f",
	"./pro4.png": "49f1",
	"./pro5.png": "6d68",
	"./pro6.png": "6794",
	"./pro7.png": "cc9e",
	"./pro8.png": "7be0",
	"./python.png": "b466",
	"./qcode.png": "a2e3",
	"./scratch.png": "7305",
	"./webdesign.png": "8b07",
	"./zuopin1.jpg": "e8cf",
	"./zuopin1.mp4": "7e59",
	"./zuopin2.jpg": "7d1d",
	"./zuopin2.mp4": "337c",
	"./zuopin3.jpg": "bdcf",
	"./zuopin3.mp4": "b12b",
	"./zuopin4.jpg": "af4b",
	"./zuopin4.mp4": "9cb6",
	"./zuopin5.jpg": "502c",
	"./zuopin5.mp4": "26c8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";